import { CseVersionTypeMap } from '../../lib/types/models/cse/cse'
import { API, constructApiUrl } from '../apis.config'
import { restApiClient } from '../rest-api-client'

export function getCseByCode<T extends keyof CseVersionTypeMap>(
  cseCode: string,
  version: T = 'BASIC' as T
) {
  return restApiClient
    .url(constructApiUrl(API.cse.getByCode.url, { cseCode }))
    .query({ version })
    .get<CseVersionTypeMap[T]>()
}
